'use client'

import { Box, BoxProps, Flex, Group, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { colorMap } from '@/app/[locale]/price/stocks/[symbol]/_components/AnalystRatings'

export type SuggestType = 'buy' | 'hold' | 'sell'

export const ColorChangeCircle = ({
  suggest,
  children,
  ...restProps
}: { suggest: SuggestType; children: React.ReactNode } & BoxProps) => {
  return (
    <Flex
      justify={'center'}
      align={'center'}
      style={{ borderRadius: 1600, background: colorMap[suggest].bg }}
      {...restProps}
    >
      {children}
    </Flex>
  )
}

export const SuggestPercentageBar = ({
  value,
  suggest,
}: {
  value: number
  suggest: SuggestType
}) => {
  const t = useTranslations('analystRating')
  return (
    <Flex gap={17}>
      <Box
        w={{ base: 183, medium: 249 }}
        h={8}
        bg={'rgba(255, 255, 255, 0.05)'}
        style={{ borderRadius: 4 }}
        pos={'relative'}
      >
        <Box
          p={'absolute'}
          w={`${value}%`}
          h={'100%'}
          left={0}
          bg={colorMap[suggest].child}
          bdrs={8}
        />
      </Box>
      <Group gap={4} wrap="nowrap">
        <Text c={'var(--content-secondary)'} variant="subtitle-number">
          {value}%
        </Text>
        <Text c={'var(--content-secondary)'} variant="subtitle-number">
          {t(suggest)}
        </Text>
      </Group>
    </Flex>
  )
}
